<template>
  <div class="home_wrap">
    <van-nav-bar
      title="Senha de Saque"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="top_tips">
      {{ $t('这是你的第一次提现。您需要设置提现密码') }}
    </div>

    <div class="sec_tips">
      {{ $t('设置您的提款密码') }}
    </div>

    <div class="th_tips">
      <span>{{ $t('新提币密码') }}</span>
      <van-icon
        name="lock"
        class="lock_icon"
      />
      <!-- <svg
        width="1.5em"
        height="1.5em"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_6389_54743)">
          <path
            d="M13.4393 0.986328L11.4085 3.01709C10.3301 2.56843 9.17339 2.33836 8.00541 2.34018C6.26835 2.30606 4.56382 2.81397 3.12876 3.79333C1.6937 4.77268 0.599436 6.17479 -0.00195312 7.80478L0.0404898 7.8091L-0.00195312 7.8134C0.530735 9.33527 1.51697 10.6574 2.82392 11.6017L1.06701 13.3586L1.93592 14.2276L14.3051 1.85832L13.4393 0.986328ZM4.33654 7.77526C4.33538 7.13331 4.50343 6.50239 4.82377 5.94608C5.14411 5.38978 5.60542 4.92773 6.16121 4.6065C6.717 4.28527 7.34761 4.11619 7.98956 4.11632C8.6315 4.11646 9.2621 4.28579 9.81776 4.60725L8.69343 5.73218C8.31122 5.60091 7.89982 5.57959 7.50608 5.67065C7.11235 5.76172 6.75211 5.9615 6.46635 6.24726C6.18059 6.53302 5.98086 6.89326 5.8898 7.287C5.79874 7.68073 5.82005 8.09212 5.95132 8.47433L4.8282 9.59741C4.506 9.04419 4.33678 8.41547 4.33654 7.77526Z"
            fill=""
          ></path>
          <path
            d="M7.9982 9.94133C8.57172 9.941 9.12163 9.71298 9.52712 9.30737C9.93261 8.90177 10.1605 8.35177 10.1607 7.77825C10.1607 7.76101 10.1607 7.74379 10.1607 7.72656L7.94531 9.94195C7.96316 9.93887 7.98035 9.94133 7.9982 9.94133Z"
            fill=""
          ></path>
          <path
            d="M16.0005 7.80245C15.5258 6.439 14.6853 5.23233 13.5709 4.31445L11.4127 6.4726C11.6661 7.13182 11.7229 7.85037 11.5762 8.54122C11.4296 9.23207 11.0857 9.86558 10.5863 10.365C10.0869 10.8644 9.45347 11.2082 8.76262 11.3549C8.07177 11.5016 7.35318 11.4448 6.69396 11.1914L5.09766 12.7877C6.03381 13.1111 7.01735 13.2763 8.00781 13.2763C9.74304 13.31 11.4456 12.8016 12.8782 11.822C14.3109 10.8424 15.4023 9.44029 16.0005 7.81105L15.9573 7.80675L16.0005 7.80245Z"
            fill=""
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_6389_54743">
            <rect
              width="16"
              height="13.2394"
              fill="white"
              transform="translate(0 0.986328)"
            ></rect>
          </clipPath>
        </defs>
      </svg> -->
    </div>

    <div class="fst_pw">
      <input-password
        v-model="password"
        @changeItem="pswChange"
      />
    </div>

    <div class="th_tips">
      <span>{{ $t('新提币密码') }}</span>
      <van-icon
        name="lock"
        class="lock_icon"
      />
    </div>

    <div class="fst_pw">
      <input-password
        v-model="password2"
        @changeItem="pswChange2"
      />
    </div>

    <div class="lst_tips">
      {{ $t('注意：提现密码保护您的资金，极其重要。请保留此信息，以免造成任何经济损失') }}
    </div>

    <div class="sum_wrap">
      <button
        class="sum_btn"
        @click="setPd()"
      >
        {{ $t('确认') }}
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { NavBar } from "vant";
import InputPassword from "../../components/password";
import Fetch from "@/utils/fetch";

Vue.use(NavBar);
export default {
  name: "Setpasswd",
  components: {
    InputPassword: InputPassword,
  },
  data() {
    return {
      password: "",
      password2: "",
    };
  },
  created() { },
  methods: {
    pswChange(password) {
      console.log(password);
    },
    pswChange2(password) {
      console.log(password);
    },
    onClickLeft() {
      this.$router.push("/");
    },
    setPd() {
      if (this.password.length != 6 || this.password2.length != 6) {
        return this.$message.error({
          message: this.$t('密码需要6位数字'),
        });
      }
      if (this.password != this.password2) {
        return this.$message.error({
          message: this.$t('两次密码不一致'),
        });
      }

      Fetch("/user/setPassword", {
        pay_password: this.password,
        re_pay_password: this.password2
      }).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: res.msg,
          });

          setTimeout(() => {
            this.$router.push("withdraw");
          }, 2000);
        } else {
          this.$message.error({
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

.sum_btn {
  width: 92%;
  border-radius: 0.2rem;
  font-size: 0.35rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  background: @ButtonColor;
  color: @primary-color;
  border: none;
}

.sum_wrap {
  width: 100%;
  max-width: @maxWidth;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: @secondary-color;
  //background-color: rgb(28, 28, 28);
}

.fst_pw {
  width: 94%;
  margin: 0.2rem auto 0.2rem auto;
}

.home_wrap {
  width: 100%;
  height: 100vh;
  background: @activityColor;
  position: relative;
}

.top_tips {
  width: 90%;
  margin: 0.5rem auto;
  text-align: center;
  color: @vipBacColor;
  line-height: 0.5rem;
}

svg path {
  fill: @popupTextColor;
}

.lst_tips {
  width: 94%;
  margin: 0.5rem auto;
  color: #ffaa09;
  line-height: 0.5rem;
  font-size: 0.3rem;
}

.sec_tips {
  width: 94%;
  margin: 0 auto;
  color: #fff;
  font-size: 0.33rem;
  font-weight: 700;
}

.th_tips {
  width: 94%;
  margin: 0.5rem auto 0 auto;
  color: #fff;
  font-size: 0.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: #fff !important;
  }
}

.lock_icon {
  font-size: 0.45rem;
  color: #fff;
}
</style>
